import type {Editor} from "slate";

/**
 * This is a Slate plugin that adds support for image elements.
 */
export const withImages = (editor: Editor): Editor => {
    const {isInline, isSelectable, isVoid} = editor;

    editor.isVoid = (element) => element.type === "image" || isVoid(element);

    editor.isInline = (element) =>
        element.type === "image" || isInline(element);

    editor.isSelectable = (element) =>
        element.type === "image" || isSelectable(element);

    return editor;
};
